import React, {useContext, useState} from 'react';
import {Route, Switch, Link, Router} from 'wouter';
import ActivityReport from './ActivityReport';
import ReportsHome from './ReportsHome';
import StudentReport from './studentReport/StudentReport';
import StudentReportSearch from "./studentReport/StudentReportSearch";
import ActivityReportSummary from "./activityReportSummaries/ActivityReportSummary";
import ActivityReportSummaryManager from "./activityReportSummaries/ActivityReportSummaryManager";
import {BrandContext} from "@context/BrandContext";

const Reports = () => {
    const BASE_URL = '/web/ui/view/reports';
    const brandConfig = useContext(BrandContext);

    return (
        <div className="ch-teacher-reports">
            {/* Navigation Links */}
            <Switch>
                <Route path={`${BASE_URL}/`}>
                    <ReportsHome />
                </Route>
                <Route path={`${BASE_URL}/activityReport/:classId?`}>
                    {(params) => {
                        return(
                                <ActivityReport
                                    classIdParam={params.classId}
                                />
                            )
                    }}
                </Route>
                <Route path={`${BASE_URL}/activityReport/:classId/student/:studentId`}>
                    {(params) => {
                        return(
                            <StudentReport
                                studentIdParam={params.studentId}
                            />
                        )
                    }}
                </Route>
                {brandConfig.useAIReportGenerator &&
                    <Route path={`${BASE_URL}/activityReport/:classId/activitySummary`}>
                        {(params) => {
                            return(
                                <ActivityReportSummary classIdParam={params.classId} />
                            )
                        }}
                    </Route>
                }
                {brandConfig.useAIReportGenerator &&
                    <Route path={`${BASE_URL}/activitySummaryManager/activitySummary`}>
                        {(params) => {
                            return(
                                <ActivityReportSummary />
                            )
                        }}
                    </Route>
                }
                {brandConfig.useAIReportGenerator &&
                    <Route path={`${BASE_URL}/activitySummaryManager/:classId/activitySummary`}>
                        {(params) => {
                            return(
                                <ActivityReportSummary classIdParam={params.classId} />
                            )
                        }}
                    </Route>
                }
                <Route path={`${BASE_URL}/studentReport`}>
                    <StudentReportSearch />
                </Route>
                <Route path={`${BASE_URL}/studentReport/:studentId?`}>
                    {(params) => {
                        return(
                            <StudentReport
                                studentIdParam={params.studentId}
                            />
                        )
                    }}
                </Route>
            </Switch>
        </div>
    );
};

export default Reports;
